
import { Component, Prop, Vue } from "vue-property-decorator";

import UploaderState from "@/components/NewFileUploader/NbNewUploader/UploaderState.vue";
import UploaderReuploadButton from "@/components/NewFileUploader/NbNewUploader/UploaderReuploadButton.vue";

import IMAGE from "@/assets/images/upload-error.svg";

const IMAGE_PROPS = {
  width: 32,
  height: 32,
};

const BUTTON_PROPS = {
  outline: true,
  small: true,
};

const MESSAGES = {
  title: "The file's size must not exceed 2 MB. Please compress and reupload it",
  list: [
    "Use this tool to compress your file",
    "Reupload the compressed file by clicking on the button below",
  ],
};

@Component({
  components: {
    UploaderState,
    UploaderReuploadButton,
  },
})
export default class FileLimitUploaderState extends Vue {
  @Prop() readonly file?;

  IMAGE = IMAGE;
  IMAGE_PROPS = IMAGE_PROPS;
  MESSAGES = MESSAGES;
  BUTTON_PROPS = BUTTON_PROPS;

  openFileSelect() {
    const target = this.$refs.file as HTMLInputElement;

    if (!target) return;

    target?.click();
  }

  reUpload(payload) {
    const target = payload.target as HTMLInputElement;

    const targetFile = target?.files?.[0];

    this.$emit("re-upload", targetFile);
  }
}
